/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Lgbtq = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/LGBTQ+"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#4BA279"
        d="M22 10c-6.627 0-12 5.373-12 12H8c0-7.732 6.268-14 14-14z"
      />
      <path
        fill="#F33"
        d="M22 4C12.059 4 4 12.059 4 22H2C2 10.954 10.954 2 22 2z"
      />
      <path
        fill="#F90"
        d="M22 6C13.163 6 6 13.163 6 22H4c0-9.941 8.059-18 18-18z"
      />
      <path
        fill="#FFC220"
        d="M22 8C14.268 8 8 14.268 8 22H6c0-8.837 7.163-16 16-16z"
      />
      <path
        fill="#4485DA"
        d="M22 12c-5.523 0-10 4.477-10 10h-2c0-6.627 5.373-12 12-12z"
      />
      <path
        fill="#8E00E5"
        d="M22 14a8 8 0 0 0-8 8h-2c0-5.523 4.477-10 10-10z"
      />
    </g>
  </svg>
);

export const LgbtqIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'lgbtq-icon'}
      icon={Lgbtq}
      {...props}
      size={size}
    />
  );
};
